(ns portfolio.events
  (:require [re-frame.core :as rf]
            [portfolio.db :as db]))

(def ^:private storage-key "portfolio.lang")

(def ^:private titles
  {:en "Alexsandro Ryan — Product Engineer · AI-native"
   :pt "Alexsandro Ryan — Engenheiro de Produto · IA-nativo"})

(defn- persist-lang! [lang]
  (try
    (.setItem js/localStorage storage-key (name lang))
    (catch :default _ nil)))

(defn- apply-lang-to-document! [lang]
  (let [html (.-documentElement js/document)]
    (set! (.-lang html) (case lang :pt "pt-BR" "en"))
    (set! (.-title js/document) (get titles lang (get titles :en)))))

(rf/reg-event-db
 ::initialize
 (fn [_ [_ initial-lang]]
   (cond-> db/default-db
     initial-lang (assoc :lang initial-lang))))

(rf/reg-event-db
 ::set-active-section
 (fn [app-db [_ section]]
   (assoc app-db :active-section section)))

;; Custom re-frame effect — keeps the lang side effects (localStorage write
;; + document.title / lang update) in one place rather than scattered.
(rf/reg-fx
 ::lang-side-effects
 (fn [lang]
   (persist-lang! lang)
   (apply-lang-to-document! lang)))

(rf/reg-event-fx
 ::set-lang
 (fn [{:keys [db]} [_ lang]]
   {:db                       (assoc db :lang lang)
    ::lang-side-effects       lang}))
